<template>
<div class="full virtual-map-info">
  <!--타이틀-->
  <el-row type="flex" justify="space-between">
    <div>
      <div class="title-bar" style="height: 43px; margin: 0 !important">
        <h3>성능/운영 타임라인</h3>
      </div>
      <p>최근 24시간 발생 히스토리 정보</p>
    </div>
    <el-button style="color: #808589; margin-top: 2px; padding: 10px !important;" type="no-border" size="large" @click="openTablePopup">
      <i class="fas fa-external-link-square-alt"></i>
    </el-button>
  </el-row>
  <!--체크박스-->
  <div>
    <el-checkbox-group class="checkbox-group" v-model="filterTypes" size="medium" @change="loadData">
      <el-checkbox-button v-for="button in filterTypeButtonList" :label="button.type" :key="button.type">
        {{ button.label }}
      </el-checkbox-button>
    </el-checkbox-group>
  </div>
  <el-scrollbar class="timeline" style="height: calc(100% - 105px);">
    <dl v-for="(timeline, index) in timelineList" :key="index" @click="onTimelineClick(timeline)">
      <dt>
        <span class="icon-dot" :style="{ backgroundColor: getTimelineColor(timeline) }"></span>
        <span class="time">{{ timeline.timestamp.split('.')[0] }}</span>
        <span class="title c-pointer" :style="{ color: getTimelineColor(timeline) }">{{ timeline.timelineTarget }}</span>
      </dt>
      <dd>{{ timeline.timelineMessage }}</dd>
      <div class="border" />
    </dl>
  </el-scrollbar>
  <w-virtual-map-timeline-popup ref="timelineTablePopup"></w-virtual-map-timeline-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import mapApi from '@/api/virtual/performance/virtualmap';
import WVirtualMapTimelinePopup from './VirtualMapTimelinePopup';

export default {
  name: 'WTimeline',
  components: {
    WVirtualMapTimelinePopup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      timelineList: [],
      filterTypeButtonList: [
        {
          type: 'EVENT',
          label: '이벤트',
        },
        {
          type: 'TROUBLE_TICKET',
          label: '장애티켓',
        },
        {
          type: 'CONFIG_CHANGE',
          label: '구성변경',
        },
        {
          type: 'WORK',
          label: '작업관리',
        },
        // {
        //   type: 'VIRTUAL',
        //   label: '가상화맵',
        // },
      ],
      filterTypes: ['EVENT', 'TROUBLE_TICKET', 'CONFIG_CHANGE', 'WORK'],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    active: {
      immediate: true,
      handler() {
        this.loadData();
      },
    },
    selectedNode: {
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    /**
     * 타임라인 조회
     * @author jeee12
     */
    loadData() {
      if (this.active) {
        const params = {
          timelineTypes: this.filterTypes,
          objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
          virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
          objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        };
        mapApi.getVirtualTimelineData(params).then((response) => {
          this.timelineList = response.data.data;
        });
      }
    },
    /**
     * 타임라인 클릭 emit
     * @author jeee12
     * @param  {[type]} timeline [description]
     */
    onTimelineClick(timeline) {
      this.$emit('select-target-map', timeline.objIds[0]);
    },
    /**
     * 타임라인 테이블 팝업 open
     * @author jeee12
     */
    openTablePopup() {
      this.$refs.timelineTablePopup.open();
    },
    /**
     * 타임라인 색상 반환
     * @author jeee12
     * @param  {[type]} eventlevelId [description]
     */
    getTimelineColor(data) {
      const defaultColor = '#7785aa';
      if (!isEmpty(data.eventlevelId)) {
        const eventInfo = this.$store.getters.eventlevelInfo[data.eventlevelId];
        return !isEmpty(eventInfo) ? eventInfo.eventlevelColorBg : defaultColor;
      }
      return defaultColor; // 로드 시점문제로 인해
    },
  },
};
</script>

<style lang="scss" scoped>
.virtual-map-info {
  height: 100%;
  margin-left: -22px;
  p {
    line-height: 4px;
    color: #999; //$lightgray
    font-size: 12px;
  }
  .checkbox-group {
    width: 100%;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapTimeline.vue